import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-company-access',
  templateUrl: './company-access.component.html',
  styles: [
  ]
})
export class CompanyAccessComponent implements OnInit {

  dataTitle;
  dataAddress;
  dataCorporate;

  constructor(private apiService: ApiService, 
              private globalService : GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/company-access').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // address
    this.apiService.getDataApi('getAddress?category=2').subscribe(response => {
        this.dataAddress = response.data[0]; 
    });

    // directors
    this.apiService.getDataApi('getDirector?category=9').subscribe(response => {
      this.dataCorporate = response.data.content;
    });
  }

}
